// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;O put your trust in God;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for I will yet give him thanks,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;who is the help of my countenance, and my God.<br> </p> </div></div>";
// Exports
module.exports = code;